import { ComponentType, useEffect, useRef } from "react"
import {
    selectBackgroundClose,
    selectOverlayComponentName,
    selectOverlayType,
} from "features/content-overlay/selectors"
import ModalMap from "features/modals/registry"
import { get } from "nodash"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { BaseModal } from "themes/default-tailwind/modals/BaseModal"
import { OverlayModalType } from "themes/default-tailwind/modals/module"
import { useLocation } from "react-router-dom"
import { closeModal } from "features/content-overlay/thunks"

/**
 * this panel uses the full screen to display important information that blocks all other ui interactions
 */
export const OverlayPanel = () => {
    const dispatch = useAppDispatch()
    const modalComponentName = useAppSelector(selectOverlayComponentName) || ""

    const backgroundClose = useAppSelector(selectBackgroundClose)
    const modalType = useAppSelector(selectOverlayType)

    const location = useLocation()
    const routeRef = useRef<string>(location.pathname)

    //when we change routes, hide any active modals
    useEffect(() => {
        if (location.pathname === routeRef.current) return
        dispatch(closeModal())
        routeRef.current = location.pathname
    }, [location.pathname, dispatch])

    const ModalComponent = get(ModalMap, [modalComponentName, "component"]) as
        | ComponentType
        | undefined
    if (!modalComponentName) {
        return null
    }

    if (!ModalComponent) {
        console.warn("Encountered an invalid modalComponentName", { modalComponentName })
        return null
    }

    const ModalContainer = BaseModal
    if (modalType === OverlayModalType.Bottom) {
        return <ModalComponent />
    }

    return (
        <ModalContainer backgroundClickToClose={backgroundClose}>
            <ModalComponent />
        </ModalContainer>
    )
}

export default OverlayPanel
